// SCSS entry file
import '../_scss/main.scss';

// Load all image files from a directory
//require.context( '../_img/', true, /.*/ );

import $ from 'jquery';

import 'magnific-popup';

import './components/root';
import './smoothscroll';
// import './cookie-script-localstorage';
//import './shave';

$('.js-sign-up__trigger').magnificPopup({
  type: 'inline',
  midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});
$('.js-play-video').magnificPopup({
  type: 'iframe',
  midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});



// WEBPACK FOOTER //
// ./assets/_js/main.js